import { List } from 'react-admin';

import { ClientInput } from '../inputs/ClientInput';
import { ClientNoteDatagrid } from './ClientNoteDatagrid';

export const ClientNoteList: React.FC = () => {
  const filters = [<ClientInput label="Klient" source="client.id" />];

  return (
    <List exporter={false} filters={filters} sort={{ field: 'updateTimestamp', order: 'DESC' }}>
      <ClientNoteDatagrid />
    </List>
  );
};
